// extracted by mini-css-extract-plugin
module.exports = {"pt-task-list":"pt-task-list-2f5040cc673ed3a02191d996c4d7df96","list-item":"list-item-88e7a4dede9dc82289aeaa4d51a86931"};